export const GET_MATERIALS = 'GET_MATERIALS';
export const CREATE_MATERIAL = 'CREATE_MATERIAL';
export const REMOVE_MATERIAL = 'REMOVE_MATERIAL';
export const UPDATE_MATERIAL = 'UPDATE_MATERIAL';
